import useFormatter from "@coworker/app/src/hooks/useFormatter";
import { ComponentNotificationFooter } from "./types/task-notification.types";
import styles from "./task-notification.module.css";
import { useTranslation } from "@coworker/locales";
import { getTaskTypeTranslateString } from "./utils/task-notification-footer";

interface TaskNotificationFooterDateAndTypeProps extends ComponentNotificationFooter {
  createdAt: string;
}
export const TaskNotificationFooterDateAndType = ({
  props: { taskType },
  createdAt,
}: TaskNotificationFooterDateAndTypeProps) => {
  const { t } = useTranslation();
  const { formatDateTimeShort } = useFormatter();
  const taskTypeTranslateString = getTaskTypeTranslateString(taskType);

  return (
    <div className={styles["task-notification-item-footer"] ?? ""}>
      {!!taskTypeTranslateString && (
        <>
          {t(taskTypeTranslateString)}
          <span
            className={styles["task-notification-item-footer-bullet"] ?? ""}
          >
            &bull;
          </span>
        </>
      )}
      <span>{`${formatDateTimeShort(createdAt)}`}</span>
    </div>
  );
};
